import React from 'react';
interface PlayIconProps extends React.SVGProps<SVGSVGElement> {
	fill?: string;
	width?: number;
	height?: number;
}

export function PlayIcon({ width = 16, height = 16, fill = 'currentColor', ...props }: Readonly<PlayIconProps>) {
	return (
		<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_857_42031)">
				<path
					d="M4 20.812V3.002a1 1 0 011.546-.838l13.668 8.905a1 1 0 010 1.675L5.546 21.65A1 1 0 014 20.813z"
					fill={fill}
				/>
			</g>
			<defs>
				<clipPath id="clip0_857_42031">
					<path fill={fill} d="M0 0H24V24H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
